import * as React from "react";
import { useParams } from "react-router-dom";
import { useGetAuditContextQuery } from "../../store/api/auditctxApi";
import { AuditContextDetailForm } from "./detailForm";
import { Loader } from "../../components/layout/loader";
import { IncorrectItem } from "../../components/generic/IncorrectItem/incorrectItem";
import { AccessRestrictedItem } from "../../components/generic/AccessRestrictedItem/accessRestrictedItem";

type RouteParams = "org" | "auditctx";
export const AuditContextDetailInitializer: React.FC = () => {
  const { org: orgName, auditctx: auditContextName } = useParams<RouteParams>();

  const selfLink = `/org/${orgName}/auditctx/${auditContextName}`;

  const { data: auditContext, isLoading, isFetching, isError, error, refetch } = useGetAuditContextQuery(selfLink, {
    skip: !selfLink,
    refetchOnMountOrArgChange: true,
  });

  if (!auditContext && isLoading) {
    return <Loader />;
  }

  const is403 = isError && (error as any)?.status === 403;
  if (is403) {
    return <AccessRestrictedItem kind="auditctx" />;
  }

  const is404 = isError && (error as any)?.status === 404;
  if (is404 || !auditContext) {
    return <IncorrectItem kind="auditctx" canCreate={true} />;
  }

  return <AuditContextDetailForm auditContext={auditContext} />;
};
